import { useTranslation } from "react-i18next";
import { Reveal } from "./Reveal";
import { scrollTo } from "./Nav";

export const CtaBanner = () => {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden border-t border-white/5 bg-[#0D0F12] px-6 py-28 lg:px-12 lg:py-36 grain" data-testid="cta-banner">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <p className="font-code text-[11px] uppercase tracking-[0.35em] text-[#D6705A]" data-testid="cta-overline">
            {t("cta.overline")}
          </p>
          <h2 className="mt-6 max-w-4xl font-display text-4xl font-light leading-[1.05] text-[#F9F8F6] sm:text-6xl lg:text-7xl" data-testid="cta-heading">
            {t("cta.h2pre")} <em className="italic text-[#D6705A]">{t("cta.h2em")}</em>{t("cta.h2post")}
          </h2>
        </Reveal>
        <div className="mt-12 flex flex-col gap-8 md:flex-row md:items-end md:justify-between">
          <Reveal delay={0.15}>
            <p className="max-w-md text-sm leading-relaxed text-[#A0A0A0] md:text-base" data-testid="cta-sub">
              {t("cta.sub")}
            </p>
          </Reveal>
          <Reveal delay={0.25}>
            <div className="flex flex-wrap items-center gap-6">
              <button
                onClick={() => scrollTo("#prenota")}
                className="rounded-full bg-[#D6705A] px-8 py-4 font-code text-[11px] uppercase tracking-[0.25em] text-[#0D0F12] transition-[background-color,transform] duration-300 hover:bg-[#F9F8F6] hover:-translate-y-1"
                data-testid="cta-banner-button"
              >
                {t("cta.button")}
              </button>
              <a
                href="mailto:info@lobiettivoimmobiliare.it"
                className="font-code text-[11px] uppercase tracking-[0.25em] text-[#A0A0A0] transition-colors duration-300 hover:text-[#F9F8F6]"
                data-testid="cta-email-link"
              >
                info@lobiettivoimmobiliare.it
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
